import React, { FC } from 'react';
import { Box } from '@mui/material';
import CompleteRegistration from '../components/LoginScreenComponents/CompleteRegistration';

const CompleteRegister: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <CompleteRegistration />
        </Box>
      </Box>
    </Box>
  );
};

export default CompleteRegister;
